/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const LockOpenIconConfig = {
  name: 'LockOpenIcon',
  height: 512,
  width: 576,
  svgPath: 'M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(LockOpenIconConfig);